export enum FileManagerEditorOutboundEventTypeEnum {
  openLibrary = 'advancedPersonalisation.openLibrary',
  getFolderContent = 'advancedPersonalisation.getFolderContent',
}
